import { httpRequest } from "@services/http";
import { PricesheetItem } from "@models/pricesheetitem.model";
import { PricesheetItemSerializer } from "@models/serializers/pricesheetitemSerializer";

export class CommandListPricesheetItems {
  async run(contractId: number, pricesheetId: number): Promise<PricesheetItem[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/items/`;
    const response = await httpRequest<any[]>(url, { method: "GET", cache: "no-store" });
    return PricesheetItemSerializer.fromJsonList(response);
  }
}
